import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "请选择需要排除的牙齿，点击某颗牙齿可切换其选择状态", -1)
const _hoisted_2 = { class: "teeth_dialog" }
const _hoisted_3 = { class: "btn_status" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon_wrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-check" })
], -1)
const _hoisted_7 = { class: "btn_status" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon_wrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-check" })
], -1)
const _hoisted_11 = { class: "btn_status" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "icon_wrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-check" })
], -1)
const _hoisted_15 = { class: "btn_status" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "icon_wrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-check" })
], -1)

import { computed, reactive, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'teethDialog',
  props: {
    visible: Boolean,
    abnormalList: {
        type:Object,
        default:()=>{
            return {
                teethIndexExcludeIsglobal:false,
                teethIndexExclude:''
            }
        }
    }
},
  emits: ['ok', 'cancel'],
  setup(__props, { emit: emits }) {

const props = __props;




const data = reactive({
    teethDialog: props.visible,
    abnormal2excludesTeethList: {
        teethIndexList: '',
        isglobal: false
    },
    teethData1: [
        "18",
        "17",
        "16",
        "15",
        "14",
        "13",
        "12",
        "11",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
    ],
    teethData2: ["55", "54", "53", "52", "51", "61", "62", "63", "64", "65"],
    teethData3: ["85", "84", "83", "82", "81", "71", "72", "73", "74", "75"],
    teethData4: [
        "48",
        "47",
        "46",
        "45",
        "44",
        "43",
        "42",
        "41",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
    ],
})

onMounted(() => {
    // let abnormalList = props.abnormalList;
    data.abnormal2excludesTeethList.isglobal = props.abnormalList.teethIndexExcludeIsglobal;
    data.abnormal2excludesTeethList.teethIndexList =
        props.abnormalList.teethIndexExclude || "";
    console.log(data.abnormal2excludesTeethList);
})

const selectTeeth = computed(() => {
    if (
        data.abnormal2excludesTeethList.teethIndexList &&
        data.abnormal2excludesTeethList.teethIndexList.length > 0
    ) {
        return data.abnormal2excludesTeethList.teethIndexList.split("|");
    } else {
        return [];
    }
})

// 点击牙齿变幻颜色的功能
const changeTeeth = (row: string) => {
    if (selectTeeth.value.includes(row)) {
        let newArr = selectTeeth.value.filter((list: string) => list !== row); //切换状态
        data.abnormal2excludesTeethList.teethIndexList = newArr.join("|");
        // monitorItems.value[data.teethIndex].teethIndexList = newArr.join("|");
        console.log(row);
        console.log(selectTeeth);
    } else {
        if (data.abnormal2excludesTeethList.teethIndexList.length > 0) {
            data.abnormal2excludesTeethList.teethIndexList += "|" + row;
        } else {
            data.abnormal2excludesTeethList.teethIndexList += row;
        }
    }
}

const submitTeeth = () => {
    console.log('');
    data.teethDialog = false
    emits('ok', data.abnormal2excludesTeethList)
}

const onCancel = () => {
    data.teethDialog = false
    emits('cancel')
}

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: data.teethDialog,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((data.teethDialog) = $event)),
      title: "排除牙齿",
      width: "1300px",
      onOk: submitTeeth,
      onCancel: onCancel
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.teethData1, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["btn_list", _unref(selectTeeth).includes(item) ? 'active' : '']),
                key: index,
                onClick: ($event: any) => (changeTeeth(item))
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(item), 1),
                _hoisted_6
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.teethData2, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["btn_list", _unref(selectTeeth).includes(item) ? 'active' : '']),
                key: index,
                onClick: ($event: any) => (changeTeeth(item))
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(item), 1),
                _hoisted_10
              ], 10, _hoisted_8))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.teethData3, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["btn_list", _unref(selectTeeth).includes(item) ? 'active' : '']),
                key: index,
                onClick: ($event: any) => (changeTeeth(item))
              }, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(item), 1),
                _hoisted_14
              ], 10, _hoisted_12))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.teethData4, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["btn_list", _unref(selectTeeth).includes(item) ? 'active' : '']),
                key: index,
                onClick: ($event: any) => (changeTeeth(item))
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(item), 1),
                _hoisted_18
              ], 10, _hoisted_16))
            }), 128))
          ])
        ]),
        _createVNode(_component_a_checkbox, {
          style: {"margin":"10px auto"},
          checked: data.abnormal2excludesTeethList.isglobal,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((data.abnormal2excludesTeethList.isglobal) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("应用到所有需要排除的地方")
          ]),
          _: 1
        }, 8, ["checked"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})